import { useMutation } from '@tanstack/react-query'

import { userToServer } from 'models/user-model'
import { patch } from 'utils/http'

export const useUpdateUser = () => {
  return useMutation({
    mutationFn: ({ userId, values }: any) => patch(`/management/users/${userId}`, userToServer(values)),
  })
}
